<script>
  import { afterUpdate, onMount } from "svelte";
  import { credsToUsd, formatMoney } from "../../util";
  import { getForms, getHighlights, getSites } from "../../services";
  import { account } from "../../store";

  let sites = [];
  let forms = [];

  $: highlights = {
    sites: 0,
    forms: 0,
  };

  $: balance = formatMoney(credsToUsd(highlights?.balance || 0), 2);
  $: mBalance = formatMoney(highlights?.subs?.monthlyUsdTotal || 0, 2);

  onMount(async () => {
    if ($account) {
      forms = await getForms();
      sites = await getSites();
      highlights = await getHighlights();
    }
  });

  afterUpdate(async () => {
    if ($account && !forms?.length) {
      forms = await getForms();
    }
    if ($account && !sites?.length) {
      sites = await getSites();
    }
  });
</script>

<!-- highlights -->
<div class="highlights">
  <hgroup>
    <h1>{balance}</h1>
    <h4>Credit Balance</h4>
  </hgroup>
  <hgroup>
    <h1>{mBalance}/m</h1>
    <h4>Monthly Charges</h4>
  </hgroup>
  <hgroup>
    <h1>{highlights?.forms ?? 0}/{highlights?.sites ?? 0}</h1>
    <h4>Forms/Sites</h4>
  </hgroup>
</div>

<style>
  :root {
    --icon-size: 2rem;
  }
  :global([disabled]) {
    opacity: 0.15;
  }
  :global(.delete-btn) {
    background: maroon;
  }
  .highlights {
    display: flex;
    gap: 2em;
    justify-content: space-between;
  }
  .highlights hgroup {
    border-radius: 10px;
    border: var(--border);
    flex: 1;
    padding: 1.2rem 2rem;
    text-align: center;
  }
  :global(.fe-icon > svg) {
    stroke-width: var(--stroke-width);
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
